/* ============================================================
   PACIOTTI JEWELS — LANDING DI LANCIO · Prossimamente
   ------------------------------------------------------------
   CONFIGURAZIONE — l'unica riga da toccare per il go-live
   ============================================================ */
const CONFIG = {
  // 'shopify'  -> crea il contatto in Shopify (Omnisend lo sincronizza da li')
  // 'endpoint' -> POST diretto all'URL in ENDPOINT
  // 'demo'     -> non invia nulla, mostra solo la conferma (per test)
  MODE: 'shopify',
  ENDPOINT: '',
  TAGS: 'newsletter, landing-lancio'
};

/* ---------------- i18n ---------------- */
const I18N = {
  it: {
    'hero.kicker':'Milano — dal 1948 — il ritorno',
    'hero.l1':'La leggenda',
    'hero.l2':'torna <em>gioiello</em>.',
    'hero.sub':'Il pugnale che ha inciso decenni di stile italiano torna nella sua forma più pura. La nuova collezione Paciotti Jewels è in uscita.',
    'hero.mic':'Accesso in anteprima per chi è in lista. Un solo invito.',
    'hero.f1':'Prossimamente',
    'hero.f2':'Online & retailer selezionati',
    'mani.eyebrow':'La storia',
    'mani.txt':'C’è una firma che non ha mai chiesto il permesso. Nata nel 1948 dal saper fare italiano, incisa come una lama in decenni di stile: portata, riconosciuta, desiderata. Oggi quella firma torna dove la materia è più pura — argento, onice, luce.',
    'mani.claim':'Non una collezione. <em>Un ritorno.</em>',
    'ant.eyebrow':'Le anteprime',
    'ant.title':'Un primo sguardo.',
    'ant.sub':'Collane, bracciali, anelli. Una sola firma.',
    'ant.c1':'Collane','ant.c2':'Bracciali','ant.c3':'Anelli',
    'bleed.cap':'La lama',
    'soon.eyebrow':'La collezione',
    'soon.word':'Prossimamente.',
    'soon.sub':'Online e nei retailer selezionati.<br>Chi è in lista entra prima.',
    'soon.cta':'Entra in lista',
    'join.eyebrow':'Accesso in anteprima',
    'join.title':'Prima di <em>chiunque.</em>',
    'join.txt':'Lascia la tua email: quando la collezione esce, entri per primo — prima che tutto vada online e nei retailer selezionati. Un solo invito. Niente rumore.',
    'join.ph':'La tua email',
    'join.cta':'Entra in lista',
    'join.micro':'Un solo messaggio: quello che conta. · <a href="/policies/privacy-policy" class="pp">Informativa privacy</a>',
    'join.err':'Controlla l’indirizzo email.',
    'join.ok1':'Benvenuto nella leggenda.',
    'join.ok2':'Il tuo posto è riservato: quando esce, lo saprai per primo.',
    'join.okline':'Posto riservato — quando esce, lo saprai per primo.',
    'foot.mid':'In uscita — online e nei retailer selezionati',
    'marq.a':'Il ritorno','marq.b':'PACIOTTI JEWELS','marq.c':'Prossimamente'
  },
  en: {
    'hero.kicker':'Milan — since 1948 — the return',
    'hero.l1':'The legend',
    'hero.l2':'returns as a <em>jewel</em>.',
    'hero.sub':'The dagger that carved decades of Italian style returns in its purest form. The new Paciotti Jewels collection is on its way.',
    'hero.mic':'Early access for the list. One invitation.',
    'hero.f1':'Coming soon',
    'hero.f2':'Online & selected retailers',
    'mani.eyebrow':'The story',
    'mani.txt':'Some signatures never asked for permission. Born in 1948 from Italian craftsmanship, carved like a blade through decades of style: worn, recognised, desired. Today that signature returns to its purest matter — silver, onyx, light.',
    'mani.claim':'Not a collection. <em>A return.</em>',
    'ant.eyebrow':'First look',
    'ant.title':'A first glimpse.',
    'ant.sub':'Necklaces, bracelets, rings. One signature.',
    'ant.c1':'Necklaces','ant.c2':'Bracelets','ant.c3':'Rings',
    'bleed.cap':'The blade',
    'soon.eyebrow':'The collection',
    'soon.word':'Coming soon.',
    'soon.sub':'Online and at selected retailers.<br>The list gets in first.',
    'soon.cta':'Join the list',
    'join.eyebrow':'Early access',
    'join.title':'Before <em>anyone.</em>',
    'join.txt':'Leave your email: when the collection drops, you get in first — before everything goes online and to selected retailers. One invitation. No noise.',
    'join.ph':'Your email',
    'join.cta':'Join the list',
    'join.micro':'One message: the one that matters. · <a href="/policies/privacy-policy" class="pp">Privacy policy</a>',
    'join.err':'Please check your email address.',
    'join.ok1':'Welcome to the legend.',
    'join.ok2':'Your place is reserved: when it drops, you’ll know first.',
    'join.okline':'Place reserved — when it drops, you’ll know first.',
    'foot.mid':'Coming soon — online and at selected retailers',
    'marq.a':'The return','marq.b':'PACIOTTI JEWELS','marq.c':'Coming soon'
  }
};
let LANG = 'it';
function applyLang(l){
  LANG = l;
  document.documentElement.lang = l;
  document.querySelectorAll('[data-i]').forEach(el=>{
    const k = el.getAttribute('data-i');
    if (I18N[l][k] != null) el.innerHTML = I18N[l][k];
  });
  document.querySelectorAll('[data-ph]').forEach(el=>{
    const k = el.getAttribute('data-ph');
    if (I18N[l][k] != null) el.placeholder = I18N[l][k];
  });
  document.querySelectorAll('.lang').forEach(b=>b.classList.toggle('on', b.dataset.lang===l));
  buildMarquee();
}
document.querySelectorAll('.lang').forEach(b=>b.addEventListener('click',()=>applyLang(b.dataset.lang)));

/* ---------------- marquee ---------------- */
function buildMarquee(){
  const t = document.getElementById('marq');
  if(!t) return;
  const unit = `<span>${I18N[LANG]['marq.a']}</span><b>—</b><b>${I18N[LANG]['marq.b']}</b><b>—</b><span>${I18N[LANG]['marq.c']}</span><b>—</b>`;
  t.innerHTML = unit.repeat(8);
}

/* ---------------- preloader ---------------- */
(function(){
  const l = document.getElementById('loader');
  const skip = location.search.includes('snap') || matchMedia('(prefers-reduced-motion:reduce)').matches;
  const done = ()=>{ l.classList.add('off'); setTimeout(()=>l.remove(), 800); startHero(); };
  if (skip){ done(); return; }
  setTimeout(done, 1750);
})();
function startHero(){
  document.querySelectorAll('.hero .rv, .claim .w').forEach(el=>el.classList.add('in'));
}

/* ---------------- reveal on scroll ---------------- */
(function(){
  const els = document.querySelectorAll('.rv:not(.hero .rv)');
  if(!('IntersectionObserver' in window)){ els.forEach(e=>e.classList.add('in')); return; }
  const io = new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
  }),{threshold:.14});
  els.forEach(e=>io.observe(e));
})();

/* ---------------- logo: grande all'ingresso, si riduce allo scroll ---------------- */
(function(){
  const logo = document.querySelector('.nav .logo');
  if(!logo) return;
  let BIG=128, SMALL=56;
  const calc = ()=>{
    BIG = Math.max(82, Math.min(innerWidth*.1445, 134));   // -15% all'atterraggio
    SMALL = innerWidth < 900 ? 49 : 56;                    // +12% da scrollato
  };
  const ease = t => 1 - Math.pow(1-t, 3);
  let tick=false;
  const set = ()=>{
    const t = Math.min(1, Math.max(0, scrollY/340));
    const e = ease(t);
    logo.style.height = (BIG - (BIG-SMALL)*e).toFixed(1) + 'px';
    const fadeBig = innerWidth < 900 ? 360 : 440;
    document.documentElement.style.setProperty('--navfade', (fadeBig - (fadeBig-150)*e).toFixed(0) + 'px');
    tick=false;
  };
  calc(); set();
  addEventListener('scroll', ()=>{ if(!tick){ requestAnimationFrame(set); tick=true; } }, {passive:true});
  addEventListener('resize', ()=>{ calc(); set(); }, {passive:true});
})();

/* ---------------- hero parallax ---------------- */
(function(){
  const im = document.getElementById('heroImg');
  if(!im || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  addEventListener('scroll',()=>{
    const y = Math.min(scrollY, innerHeight);
    im.style.translate = `0 ${y*0.14}px`;
  },{passive:true});
})();

/* ---------------- form (hero + fondo) ---------------- */
// document.querySelectorAll('.nl-form').forEach(form=>{
//   const input = form.querySelector('input[type=email]');
//   const err = form.querySelector('.form-err');
//   const btn = form.querySelector('button[type=submit]');
//   let ok = form.nextElementSibling;
//   if(!(ok && ok.classList.contains('form-ok'))) ok = form.parentElement.querySelector('.form-ok');
//   form.addEventListener('submit', async e=>{
//     e.preventDefault();
//     err.classList.remove('on');
//     const v = (input.value||'').trim();
//     if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)){ err.classList.add('on'); input.focus(); return; }
//     btn.disabled = true; btn.style.opacity=.55;
//     try{
//       if (CONFIG.MODE === 'shopify'){
//         const body = new URLSearchParams();
//         body.append('form_type','customer');
//         body.append('utf8','✓');
//         body.append('contact[email]', v);
//         if (CONFIG.TAGS) body.append('contact[tags]', CONFIG.TAGS);
//         const res = await fetch('/contact', { method:'POST', body });
//         if(!res.ok) throw new Error('subscribe failed');
//       } else if (CONFIG.MODE === 'endpoint' && CONFIG.ENDPOINT){
//         const res = await fetch(CONFIG.ENDPOINT,{
//           method:'POST',
//           headers:{'Content-Type':'application/json'},
//           body: JSON.stringify({ email:v, source:'landing-lancio', lang:LANG })
//         });
//         if(!res.ok) throw new Error('subscribe failed');
//       } else {
//         await new Promise(r=>setTimeout(r,900)); // demo
//       }
//       form.style.display='none';
//       if(ok){ ok.classList.add('on'); requestAnimationFrame(()=>requestAnimationFrame(()=>ok.classList.add('vis'))); }
//     }catch(_){
//       btn.disabled=false; btn.style.opacity=1;
//       err.textContent = LANG==='it' ? 'Qualcosa non ha funzionato. Riprova.' : 'Something went wrong. Try again.';
//       err.classList.add('on');
//     }
//   });
// });

/* ---------------- cursore custom ---------------- */
(function(){
  const c=document.getElementById('cur'), d=document.getElementById('curDot');
  if(!c || !matchMedia('(pointer:fine)').matches) return;
  let x=innerWidth/2,y=innerHeight/2,cx=x,cy=y;
  addEventListener('pointermove',e=>{x=e.clientX;y=e.clientY;
    d.style.transform=`translate(${x-2}px,${y-2}px)`;
  });
  (function loop(){
    cx+=(x-cx)*.14; cy+=(y-cy)*.14;
    c.style.transform=`translate(${cx-17}px,${cy-17}px)`;
    requestAnimationFrame(loop);
  })();
  document.querySelectorAll('a,button,input').forEach(el=>{
    el.addEventListener('pointerenter',()=>c.classList.add('big'));
    el.addEventListener('pointerleave',()=>c.classList.remove('big'));
  });
})();

/* ---------------- bottoni magnetici ---------------- */
(function(){
  if(!matchMedia('(pointer:fine)').matches) return;
  document.querySelectorAll('.mag').forEach(b=>{
    b.addEventListener('pointermove',e=>{
      const r=b.getBoundingClientRect();
      const dx=(e.clientX-r.left-r.width/2)*.18, dy=(e.clientY-r.top-r.height/2)*.3;
      b.style.transform=`translate(${dx}px,${dy}px)`;
    });
    b.addEventListener('pointerleave',()=>{ b.style.transform=''; });
  });
})();

/* ---------------- init ---------------- */
applyLang('it');
if (location.search.includes('snap')) {
  document.querySelectorAll('.rv,.claim .w').forEach(el=>el.classList.add('in'));
}